const $inject = [];

const lbaSubHeading = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '='
    },
    bindToController: true,
    controller: 'lbaSubHeadingCtrl',
    controllerAs: 'vm',
    template: require('./lbaSubHeading.html')
  }
};

lbaSubHeading.$inject = $inject;

export default lbaSubHeading;



// WEBPACK FOOTER //
// ./src/components/lbaSubHeading/lbaSubHeadingDir.js